<template>
  <div class='question-page'>
    <div class='background-wave'></div>
    <div class="question-container">
      <div class='question-title'>UNE QUESTION ?</div>
      <div class='question-underline'></div>
      <div class='question-details'>
        <div class='question-faq-details'>
          <div class='question-title'>FAQ</div>
          <FaqQuestionComponent :questions='questions'></FaqQuestionComponent>
        </div>
        <div class='question-contact-details'>
          <div class='question-title contact'>CONTACTEZ-NOUS</div>
          <ContactQuestionComponent :shadow="true"></ContactQuestionComponent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FaqQuestionComponent from '@/components/question/FaqQuestionComponent'
import ContactQuestionComponent from '@/components/question/ContactQuestionComponent'

import data from '@/data/fixtures'

export default {
  name: 'QuestionPage',

  metaInfo: {
    title: "Shokunin, les formations de L'Atelier - Une question ? La FAQ pour y répondre",
    meta: [{
      vmid: 'description',
      name: 'description',
      content: 'Vous avez une question sur le centre de formation Shokunin ? Consultez notre foire aux questions ou contactez-nous directement.'
    }]
  },

  components: {
    FaqQuestionComponent,
    ContactQuestionComponent
  },
  data () {
    return {
      questions: data.questions
    }
  },
  created () {
    window.document.title = "Shokunin, les formations de L'Atelier - Une question ? La FAQ pour y répondre"
  }
}
</script>

<style lang='scss'>
.question-page {
  display: flex;
  justify-content: center;
  align-items: flex-start;

  flex-direction: row;

  min-height: 100vh;
  min-width: 100vw;

  background: #f1f1f1;
}

.question-container {
  z-index: 20;
  max-width: 1229px;
  width: 100%;

  padding-top: 76px;

  margin: 64px 16px;

  @include media(tablet) {
    margin: 64px 24px;
  }
}

.background-wave {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  background-image: url('../assets/vagu4 5.png');
  background-repeat: no-repeat;
  background-position: top right;
  background-size: 30%;
  height: 100%;
}

.question-title {
  @extend %default-title;

  letter-spacing: 2px !important;
}

.question-underline {
  @extend %default-underline;
}

.question-details {
  display: grid;
  grid-template-columns: 45% 45%;
  grid-template-rows: 100%;
  justify-content: space-between;

  @include media(tablet) {
    display: block;
  }

  .question-title {
    font-family: 'Raleway', sans-serif;
    letter-spacing: 1.2px;
    align-self: flex-start;
    background-color: #BFBFBF;
    color: #FFFFFF;
    font-size: 1.2rem;
    font-weight: 500;
    grid-column: 1;
    grid-row: 1;
    letter-spacing: -0.05px;
    line-height: 40px;
    text-align: center;
    width: 100%;
    border-radius: 2px;

    @include media(phone) {
      margin-bottom: 24px;

      &.contact {
        margin-bottom: 0px;
      }
    }
  }

  .question-faq-details {
    display: grid;
    grid-column: 1;
    grid-template-columns: 1;
    grid-template-rows: 100px 100%;
    grid-row: 1;

    @include media(phone) {
      display: block;
    }
  }

  .question-contact-details {
    display: grid;
    grid-column: 2;
    grid-template-columns: 1;
    grid-template-rows: 100px 100%;
    grid-row: 1;

    @include media(tablet) {
      display: block;
      margin-top: 64px;
    }
  }
}
</style>
